import React from "react"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import ModalButtons from "../ModalButtons/ModalButtons"
import Tabs from '../Tabs/Tabs'
import ReservationSettingBuilderTabContent from  "./ReservationSettingBuilderTabContent"
import DateHelper from "../DateHelper/DateHelper"
import { parseISO } from 'date-fns'


export default class ReservationSettingBuilder extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
        loading: false,
        active_tab: 'general',

        date: this.props.date,
        date_formats: this.props.date_formats || [],
        time: this.props.time,
        time_formats: this.props.time_formats || [],

        id: this.props.reservation_setting.id || null,
        erorrs: this.props.errors || {},
        // check_in_time: this.props.reservation_setting.check_in_time || null,
        // check_out_time: this.props.reservation_setting.check_out_time || null,
        check_in_time: this.props.reservation_setting.check_in_time ? new Date(this.props.reservation_setting.check_in_time) : null,
        check_out_time: this.props.reservation_setting.check_out_time ? new Date(this.props.reservation_setting.check_out_time) : null,
        // minimum_stay: this.props.reservation_setting.minimum_stay || null,
        maximum_stay: this.props.reservation_setting.maximum_stay || null,
        date_format: this.props.reservation_setting.date_format || null,
        time_format: this.props.reservation_setting.time_format || null,
        auto_assign: this.props.reservation_setting.auto_assign,


    }
    this.onChange = this.onChange.bind(this)
    this.onChangeCheckIn = this.onChangeCheckIn.bind(this)
    this.onChangeCheckOut = this.onChangeCheckOut.bind(this)
    this.onChangeDate = this.onChangeDate.bind(this)
    this.onChangeTime = this.onChangeTime.bind(this)
    this.onChangeAutoAssign = this.onChangeAutoAssign.bind(this)
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)


  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  onChangeCheckIn(check_in_time) {
    this.setState({
      check_in_time: check_in_time
    })
  }

  onChangeCheckOut(check_out_time) {
    this.setState({
      check_out_time: check_out_time
    })
  }

  onChangeTime(e) {
    this.setState({
      time_format: e.target.value
    })
  }
  onChangeDate(e) {
    this.setState({
      date_format: e.target.value
    })
  }

  onChangeAutoAssign(auto_assign) {
    this.setState({
      auto_assign: auto_assign.target.checked
    })
  }


  onChangeActiveTab(name) {
    this.setState({
      active_tab: name
    })
  }

  render() {

    var self = this;
    var dateFormat = DateHelper.rubyToDateJS(this.props.date_format)
    // var timeFormat = DateHelper.rubyToDateJS(this.props.date_format)
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ]
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: function (e) {
          self.onSave()
          return false
        },
      },
    ]
    return (
      <div className="incidental-deposit-builder">
        <Tabs tabs={this.Tabs()} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <ReservationSettingBuilderTabContent {...this.state}
            time_format={this.props.time_format}
            onChange={this.onChange}
            onChangeCheckIn={this.onChangeCheckIn}
            onChangeCheckOut={this.onChangeCheckOut}
            onChangeDate = {this.onChangeDate}
            onChangeTime = {this.onChangeTime}
            onChangeAutoAssign = {this.onChangeAutoAssign}
            onChangeActiveTab = {this.onChangeActiveTab}/>
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }

  prepParams() {

    var reservation_setting = {
      check_in_time: this.state.check_in_time,
      check_out_time: this.state.check_out_time,
      // minimum_stay: this.state.minimum_stay,
      maximum_stay: this.state.maximum_stay,
      auto_assign: this.state.auto_assign,
      date_format: "",
      time_format: "",
    }
    reservation_setting.time_format = this.state.time_format
    reservation_setting.date_format = this.props.date_formats[this.state.date_format]
    if(reservation_setting.auto_assign == null) {
      reservation_setting.auto_assign = false
    }
    return reservation_setting
  }

  onSave() {
    var reservation_setting = this.prepParams()
    this.setState({loading: true})
    $.ajax({
      type: 'POST',
      url: "/admin/reservation-settings/update",
      data: {
          reservation_setting: reservation_setting
      }
    }).done((data) => {
      // console.log("data", data)
      this.setState({loading: false})
      if(Object.keys(data.errors).length) this.setState({errors: data.errors})
      else {
        window.parent.$(window.parent).trigger('reservationSettingSaved', data)
        if (parent && parent.refresh_data) {
          parent.refresh_data(I18n.t('reservation_settings_saved_successfully'))
        }
        if (parent && parent.hide_modal) {
          parent.hide_modal()
        }
      }
    })
  }

  Tabs() {
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.onChangeActiveTab,
        },
      ]
    );

  };

};
